<!--日常投入组件-->
<template>
    <div>
        <!--面包屑导航-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>养殖日志</el-breadcrumb-item>
            <el-breadcrumb-item>日常投入</el-breadcrumb-item>
        </el-breadcrumb>
        <!--添加日常投入-->
        <el-button type="primary" icon="el-icon-plus" style="margin-bottom: 15px" @click="add">添加</el-button>
        <el-dialog title="添加日常投入" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="投入总价(元)" prop="total" :label-width="formLabelWidth">
                    <el-input v-model="form.total" autocomplete="off" placeholder="填写投入总价(元)"></el-input>
                </el-form-item>
                <el-form-item label="投入品类型" prop="type" :label-width="formLabelWidth">
                    <el-select @change="getPesticideList" v-model="form.type" placeholder="选择投入品类型">
                        <el-option label="饵料" value="饵料"></el-option>
                        <el-option label="药品" value="药品"></el-option>
                       <!-- <el-option label="种苗" value="种苗"></el-option>-->
                        <!--<el-option label="其他" value="其他"></el-option>-->
                    </el-select>
                </el-form-item>
                <el-form-item label="饵料类型" :label-width="formLabelWidth" >
                    <el-select :disabled="isDisabled"  v-model="form.pesticide" placeholder="选择饵料类型">
                        <el-option  v-for="item in pesticideList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="饵料数量" prop="unit" :label-width="formLabelWidth" >
                    <el-input v-model="form.count" :disabled="isDisabled" autocomplete="off" placeholder="输入饵料数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select :disabled="isDisabled"  v-model="form.unit"  placeholder="选择饵料数量单位">
                        <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水质改良剂" :label-width="formLabelWidth">
                    <el-select :disabled="isDrugAble" v-model="form.drug" placeholder="选择改良药剂">
                        <el-option  v-for="item in drugList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水质改良剂数量" prop="unit" :label-width="formLabelWidth" >
                    <el-input v-model="form.drugCount" :disabled="isDrugAble" autocomplete="off" placeholder="输入水质改良剂数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select :disabled="isDrugAble"  v-model="form.drugUnit"  placeholder="选择水质改良剂数量单位">
                        <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="塘口名称" prop="cellId" :label-width="formLabelWidth">
                    <el-select v-model="form.cellId" placeholder="选择所属塘口">
                        <el-option  v-for="item in pondNameList" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item label="活动时间" :label-width="formLabelWidth">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="form.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="description" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="form.description" placeholder="请添加投入品描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeAdd">取 消</el-button>
                <el-button type="primary" @click="submitDailyIncomeAdd('form')">确 定</el-button>
            </div>
        </el-dialog>
        <!--更新日常收入-->
        <el-dialog title="更新日常投入" :visible.sync="updateDialogFormVisible">
            <el-form :model="updateForm" :rules="rules" ref="form">
                <el-form-item label="投入总价(元)" prop="total" :label-width="formLabelWidth">
                    <el-input v-model="updateForm.total" autocomplete="off" placeholder="填写投入总价(元)"></el-input>
                </el-form-item>
                <el-form-item label="投入品类型" prop="type" :label-width="formLabelWidth">
                    <el-select @change="getPesticideList" v-model="updateForm.type" placeholder="选择投入品类型">
                        <el-option label="饵料" value="饵料"></el-option>
                        <el-option label="药品" value="药品"></el-option>
                        <!-- <el-option label="种苗" value="种苗"></el-option>-->
                        <!--<el-option label="其他" value="其他"></el-option>-->
                    </el-select>
                </el-form-item>
                <el-form-item label="饵料类型" :label-width="formLabelWidth" >
                    <el-select :disabled="isDisabled"  v-model="updateForm.pesticide" placeholder="选择饵料类型">
                        <el-option  v-for="item in pesticideList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="饵料数量" prop="unit" :label-width="formLabelWidth" >
                    <el-input v-model="updateForm.count" :disabled="isDisabled" autocomplete="off" placeholder="输入饵料数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select :disabled="isDisabled"  v-model="updateForm.unit"  placeholder="选择饵料数量单位">
                        <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水质改良剂" :label-width="formLabelWidth">
                    <el-select :disabled="isDrugAble" v-model="updateForm.drug" placeholder="选择改良药剂">
                        <el-option  v-for="item in drugList" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="水质改良剂数量" prop="unit" :label-width="formLabelWidth" >
                    <el-input v-model="updateForm.drugCount" :disabled="isDrugAble" autocomplete="off" placeholder="输入水质改良剂数量" style="width: 200px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    <el-select :disabled="isDrugAble"  v-model="updateForm.drugUnit"  placeholder="选择水质改良剂数量单位">
                        <el-option  v-for="item in ['斤','升']" :key="item" :label="item"
                                    :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间" :label-width="formLabelWidth" prop="time">
                    <el-col :span="10">
                        <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="updateForm.date" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="1">----</el-col>
                    <el-col :span="10">
                        <el-time-picker placeholder="选择时间" value-format="HH:mm:ss" v-model="updateForm.time" style="width: 100%;"></el-time-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="其他信息" prop="description" :label-width="formLabelWidth">
                    <el-input type="textarea" v-model="updateForm.description" placeholder="请添加投入品描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeUpdate">取 消</el-button>
                <el-button type="primary" @click="makeHandleUpdate">确 定</el-button>
            </div>
        </el-dialog>
        <!--表格区域-->
        <!--.slice((currentPage-1) * pageSize,currentPage * pageSize)-->
        <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
            <el-table-column prop="type" label="名称" align="center"></el-table-column>
            <el-table-column prop="total" label="投入价格" align="center"></el-table-column>
            <el-table-column prop="count" label="投入量" align="center"></el-table-column>
            <el-table-column prop="sysTime" label="填写时间" align="center"></el-table-column>
            <el-table-column prop="description" label="描述(投入方式)" align="center"></el-table-column>
            <el-table-column width="300" align="center" fixed="right" label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleUpdate(scope.row)" type="primary" icon="el-icon-edit" size="medium">修改</el-button>
                    <el-button @click="handleDelete(scope.row)" type="danger" icon="el-icon-delete" size="medium">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <el-pagination background
                       layout="prev, pager, next"
                       :total="total"
                       :current-page="currentPage"
                       :page-size="pageSize"
                       style="text-align: center;margin-top: 10px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentPage" >
        </el-pagination>
    </div>
</template>

<script>
    import request from '../../../http/dialog'
    import {positiveNumber} from '../../../utils/validate'
    export default {
        name: "dailyIncome",
        inject: ['reload'],
        data(){
            return{
                tableData: [], /*表格列表数据*/
                isDisabled:true,/*下拉框是否可用*/
                isDrugAble:true,//改良药剂下拉列表是否可用
                currentPage: 1, // 初始页
                pageSize: 8 ,//    每页的数据
                total:0,// 列表总数
                /*添加弹出表单*/
                form: {
                    total: '',/*投入量*/
                    type: '', /*投入品类型*/
                    cellId: '', /*塘口名称*/
                    description: '', /*投入品描述信息*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    pesticide: '', /*饵料类型*/
                    count: '', /*饵料数量*/
                    unit: '',/*饵料单位(斤)*/
                    drug:'',//药品列表
                    drugCount:'',// 药品数量
                    drugUnit:'' // 药品单位
                },
                /*更新弹出表单*/
                updateForm: {
                    total: '',/*投入量*/
                    type: '', /*投入品类型*/
                    cellId: '', /*塘口名称*/
                    description: '', /*投入品描述信息*/
                    date: '',/*年月日*/
                    time: '',/*时分秒*/
                    pesticide: '', /*饵料类型*/
                    count: '', /*饵料数量*/
                    unit: '',/*饵料单位(斤)*/
                    drug:'',//药品列表
                    drugCount:'',// 药品数量
                    drugUnit:'' // 药品单位
                },
                sysTime:'',//更新时间
                formLabelWidth: '120px', //表单宽度
                /*添加弹出表单默认属性为false*/
                dialogFormVisible: false,
                /*更新弹出表单默认属性为false*/
                updateDialogFormVisible: false,
                pondNameList: [],//存放塘口名称数组
                pesticideList: [], //存放饵料类型数组
                loading: true, //table区域加载
                drugList:[],//改良药剂列表
                rules: {
                    total: [{ validator: positiveNumber, trigger: 'blur' }],
                    type: [{ required: true, message: '请选择投入品类型', trigger: 'change' }],
                    time: [{ required: true, message: '请选择时间', trigger: 'change' }],
                }
            }
        },
        methods:{
            /*选中类型(饵料)获取类型*/
            async getPesticideList(e){
                if(e === '饵料'){
                    this.isDisabled = false
                    this.isDrugAble = true
                    let res = await request.getPesticideList()
                    this.pesticideList = res.data.data
                    // console.log(res);
                }else if (e === '药品'){
                    this.isDrugAble = false
                    this.isDisabled = true
                    this.form.feed = ''
                    let res = await request.getDrugList()
                    console.log(res.data)
                    this.drugList = res.data
                } else {
                    this.isDisabled = true // 下拉框不可见
                    this.form.pesticide = ''// 饵料类型置为空
                    this.from.drug = '' //药品列表为空
                }
            },
            // 取消添加
            closeAdd(){
                this.dialogFormVisible = false
                this.$message.info('取消添加')
            },
            /*获取表格列表*/
            async getTableList(){
                let data = {
                    pageNum:this.currentPage,
                    pageSize: this.pageSize
                }
                let table = await request.dailyTableList(data)
                this.tableData = table.data.data.list
                this.total = table.data.data.total
                this.loading = false
               // console.log('日常投入列表',table);
                //console.log(this.tableData);
            },
            // 删除操作
            handleDelete(data) {
                //console.log(data)
                this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id = data.id
                    // 删除请求
                    request.deleteDailyIncome(id).then(() => { // 异步操作执行完再执行里面的内容
                        // console.log(res);
                        this.reload()// 刷新页面显示最新状态
                        this.$message.success('删除成功!')
                    })
                }).catch(() => {
                    this.$message.info('已取消删除')
                })
            },
            // 更新操作
            handleUpdate(data){
                // console.log(data);
                this.updateDialogFormVisible = true;
                this.updateForm = data
                this.sysTime = data.sysTime
                /*let sysTime = data.sysTime.split(' ') // 按照空格分隔时间
                console.log(sysTime);
                this.updateForm.date = sysTime[0]
                this.updateForm.time = sysTime[1]*/
            },
            // 确认更新
            async makeHandleUpdate(){
                this.updateDialogFormVisible = false
                // console.log(this.updateForm);
                let sendData = { /*更新日常传入数据*/
                    id: this.updateForm.id, /*id*/
                    total: this.updateForm.total,/*投入品总价*/
                    cellId: this.form.cellId, //this.form.cellId 塘口名称
                    description: this.updateForm.description,  /*投入品描述信息*/
                    type: this.updateForm.type,/*投入品类型*/
                    username: window.sessionStorage.getItem('name'),/*用户名*/
                    sysTime: this.sysTime ,/*用户自定义时间this.updateForm.date + ' '+this.updateForm.time*/
                    unit: '', /*饵料单位(斤)*/
                    count: '', /*饵料数量*/
                }
                if (this.updateForm.pesticide)
                {
                    sendData.type = this.updateForm.pesticide
                }
                if (this.updateForm.drug )
                {
                    sendData.type = this.updateForm.drug
                }
                // if (this.updateForm.drug === '环境改良类（底质改良、水质改良、生态条件改良）'){
                //     sendData.type = '环境改良类'
                // }
                if (this.updateForm.count && this.updateForm.unit){
                    sendData.unit = this.updateForm.unit
                    sendData.count = this.updateForm.count
                }
                if (this.updateForm.drugCount && this.updateForm.drugUnit){
                    sendData.unit = this.updateForm.drugUnit
                    sendData.count = this.updateForm.drugCount
                }
                if (this.updateForm.date && this.updateForm.time){
                    sendData.sysTime = this.updateForm.date + ' '+this.updateForm.time
                }
                //console.log(sendData);
                let res = await request.updateDailyIncome(sendData)
                //console.log(res);
                if (res.data.msg === 'SUCCESS') {
                    this.$message.success('更新成功')
                    this.reload() // 局部刷新这里
                }else {
                    this.$message.info('更新失败')
                }
            },
            closeUpdate () { // 取消更新
                this.updateDialogFormVisible = false
                this.$message.info('取消更新')
            },
            // pageSize改变时触发
            handleSizeChange (size) {
                this.pagesize = size
                //console.log('handleSizeChange')
            },
            // 当前页面改变时触发
            handleCurrentPage (currentPage) {
                //console.log(currentPage)
                this.currentPage = currentPage
                this.getTableList()
                //console.log('handleCurrentPage')
            },
            /*添加固定成本按钮方法*/
            async add(){
                this.dialogFormVisible = true;
                /*获取用户名传参给获取塘口名称列表请求函数*/
                /*let name = window.sessionStorage.getItem('name')
                let pondList =await request.getPondList(name)
                // console.log(pondList);
                this.pondNameList = pondList.data.data.list*/
             },
            /*添加日常收入请求,添加table列表*/
             submitDailyIncomeAdd(form){
                this.$refs[form].validate(async (valid) => {
                    if (valid) {
                        //console.log(this.form);
                        this.dialogFormVisible = false
                        let addData = { /*添加固定收入传入数据*/
                            total: this.form.total,/*投入品总价*/
                            cellId: this.form.cellId, //this.form.cellId 塘口名称
                            description: this.form.description,  /*投入品描述信息*/
                            type: this.form.type,/*投入品类型*/
                            username: window.sessionStorage.getItem('name'),/*用户名*/
                            sysTime: this.form.date + ' '+this.form.time ,/*用户自定义时间*/
                            unit: '', /*饵料单位(斤)*/
                            count: '', /*饵料数量*/
                        }
                        if (this.form.pesticide)
                        {
                            addData.type = this.form.pesticide
                        }
                        if (this.form.drug)
                        {
                            addData.type = this.form.drug
                        }
                        if (this.form.count && this.form.unit){
                            addData.unit = this.form.unit
                            addData.count = this.form.count
                        }
                        if (this.form.drugCount && this.form.drugUnit){
                            addData.unit = this.form.drugUnit
                            addData.count = this.form.drugCount
                        }
                        //console.log(addData);
                        let tempAddData = await request.dailyTableListAdd(addData)
                        //console.log(tempAddData);
                        if (tempAddData.data){
                            this.$message.success('添加成功')
                            // location.reload()
                            this.reload()
                        }
                    } else {
                        console.log('error submit!!');
                        this.$message.error('添加失败')
                        return false;
                    }
                });

            },
            /*获取塘口列表*/
            async getPondId(){
                let res = await request.getPondList(window.sessionStorage.getItem('name'));
                // console.log("塘口id",res);
               if(res.data.data.list.length){
                   this.form.cellId = res.data.data.list[0].id;
               }else {
                   this.form.cellId = 0;
               }
                // this.updateForm.cellId = res.data.data.list[0].id;
            }
        },
        created() {
            this.getTableList();
            this.getPondId()
        }
    }
</script>

<style scoped>
    /*使用深度选择器修改分页器颜色样式*/
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1abc9c;
        color: #FFF;
    }
</style>
